import { render } from "./CollectionPostTextSettingsPanel.vue?vue&type=template&id=098615e4&scoped=true"
import script from "./CollectionPostTextSettingsPanel.vue?vue&type=script&lang=js"
export * from "./CollectionPostTextSettingsPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-098615e4"]])

export default __exports__